const WideRangeSection = () => {
  return (
    <div
      className="section-full py-2 site-bg-white twm-w-range-section-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">
        {/* TITLE START */}
        <div className="section-head center">
          <div className="twm-sm-title left">
            Garud Cab Service
          </div>

          <h2 className="twm-large-title site-text-dark">
            Reliable Cab Services in Pune & Outstation
          </h2>
        </div>
        {/* TITLE END */}

        <div className="section-content">
          <div className="row twm-w-range-section">

            {/* One block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/* <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img
                    src="/images/icons/rental.png"
                    alt="Cab Trips"
                  />
                </div>

                <span className="counter">20k</span>
                <em className="symble">+</em>

                <h3 className="icon-content-info">
                  Trips Completed
                </h3>
              </div> */}

              <div className="twm-cntr-with-icon">
  <div className="icon-media">
    <img
      src="/images/icons/rental.png"
      alt="Cab Trips"
    />
  </div>

  <div className="twm-counter-wrap">
    <span className="counter">20k</span>
    <span className="symble">+</span>
  </div>

  <h3 className="icon-content-info">
    Trips Completed
  </h3>
</div>

            </div>

            {/* Two block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/* <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img
                    src="/images/icons/man.png"
                    alt="Happy Customers"
                  />
                </div>

                <span className="counter">10k</span>
                <em className="symble">+</em>

                <h3 className="icon-content-info">
                  Happy Customers
                </h3>
              </div> */}


              <div className="twm-cntr-with-icon">
  <div className="icon-media">
    <img
      src="/images/icons/man.png"
      alt="Happy Customers"
    />
  </div>

  <div className="twm-counter-wrap">
    <span className="counter">10k</span>
    <span className="symble">+</span>
  </div>

  <h3 className="icon-content-info">
    Happy Customers
  </h3>
</div>

            </div>

            {/* Three block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/* <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img
                    src="/images/icons/car-insurance.png"
                    alt="Outstation Cabs"
                  />
                </div>

                <span className="counter">50</span>
                <em className="symble">+</em>

                <h3 className="icon-content-info">
                  Cabs & Vehicles
                </h3>
              </div> */}


              <div className="twm-cntr-with-icon">
  <div className="icon-media">
    <img
      src="/images/icons/car-insurance.png"
      alt="Outstation Cabs"
    />
  </div>

  <div className="twm-counter-wrap">
    <span className="counter">50</span>
    <span className="symble">+</span>
  </div>

  <h3 className="icon-content-info">
    Cabs & Vehicles
  </h3>
</div>

            </div>

            {/* Four block */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              {/* <div className="twm-cntr-with-icon">
                <div className="icon-media">
                  <img
                    src="/images/icons/work-time.png"
                    alt="Cab Service"
                  />
                </div>

                <span className="counter">24</span>
                <em className="symble">/7</em>

                <h3 className="icon-content-info">
                  Cab Booking Service
                </h3>
              </div> */
              
              
              }


<div className="twm-cntr-with-icon">
  <div className="icon-media">
    <img
      src="/images/icons/work-time.png"
      alt="Cab Service"
    />
  </div>

  <div className="twm-counter-wrap">
    <span className="counter">24</span>
    <span className="symble">/7</span>
  </div>

  <h3 className="icon-content-info">
    Cab Booking Service
  </h3>
</div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default WideRangeSection;
